/* eslint-disable camelcase */
import {wrap} from '../shared/loading-overlay'

import {formatQualificationDateToPqe} from '../shared/services/format-pqe'
;(function module() {
  angular.module('app.ui.form.ctrls').controller('MakeMeAnOfferController', [
    '$location',
    '$scope',
    'logger',
    '$translate',
    '$anchorScroll',
    'SharedApi',
    'CandidateProfileApi',
    'practiceAreaService',
    'locationsGenericService',
    'MakeMeAnOfferApi',
    'MatchesApi',
    'usSpinnerService',
    '$timeout',
    '$uibModal',
    'userService',
    'socket',
    'sharedProperties',

    function controller(
      $location,
      $scope,
      logger,
      $translate,
      $anchorScroll,
      SharedApi,
      CandidateProfileApi,
      practiceAreaService,
      locationsGenericService,
      MakeMeAnOfferApi,
      MatchesApi,
      usSpinnerService,
      $timeout,
      $uibModal,
      userService,
      socket,
      sharedProperties
    ) {
      $translate.use('en')
      let vm = this
      socket.on('CANDIDATE_APPROVAL_STATUS_UPDATE', async data => {
        $timeout(() => {
          if (
            vm.user.id === data &&
            $location.url().contains('opportunities')
          ) {
            vm.initializeMakeMeAnOfferPage()
          }
        }, 2000)
      })

      socket.on('CANDIDATE_RECOMMENDATION_GENERATED', async candidateId => {
        $timeout(() => {
          if (
            vm.user.id === candidateId &&
            $location.url().contains('opportunities')
          ) {
            vm.select(vm.currentPage)
          }
        }, 1500)
      })

      socket.on('CANDIDATE_ASSIGNED_AGENT_UPDATE', async candidateId => {
        $timeout(async () => {
          if (
            vm.user.id === candidateId &&
            $location.url().contains('opportunities')
          ) {
            const {data: candidate} = await CandidateProfileApi.getUserProfile(
              vm.user.id
            )
            vm.candidateAgent = await sharedProperties.getAgentDetails(
              candidate.agent
            )
            $scope.$applyAsync()
          }
        }, 1000)
      })

      socket.on('CANDIDATE_PROFILE_AGENT_UPDATE', async candidateId => {
        $timeout(async () => {
          if (
            vm.user.id === candidateId &&
            $location.url().contains('opportunities')
          ) {
            const {data: candidate} = await CandidateProfileApi.getUserProfile(
              vm.user.id
            )
            vm.candidateAgent = await sharedProperties.getAgentDetails(
              candidate.agent
            )
            $scope.$applyAsync()
          }
        }, 1000)
      })

      vm.candidateEmployerRecommendations = []
      vm.currentPage = 1
      vm.noEmployers = false
      vm.selectedPracticeArea = undefined
      vm.selectedLocations = undefined
      vm.candidateLocations = []
      vm.candidateSpecialties = []
      vm.fetchHiddenJobs = false
      vm.numPerPageOpt = [10, 20, 50]
      vm.numPerPage = vm.numPerPageOpt[2]
      vm.totalPositions = 0
      vm.countRefreshReq = false
      vm.today = new Date()
      vm.picSrc = 'images/firm-logo-default.jpg'
      vm.hideJobFilterButton = false
      vm.toolTipText = 'You have already shared your profile.'
      vm.pageName = 'opportunities'

      vm.spinnerActive = false
      vm.alertOne =
        'Unfortunately there are no current opportunities on LexStep for which your profile is a relevant match.  You will be alerted when a relevant opportunity match arises.  You can also edit your '
      vm.alertTwo =
        ' to refine your search parameters and reveal potential opportunities.'

      vm.startSpin = () => {
        if (!vm.spinnerActive) {
          usSpinnerService.spin('spinner-2')
          vm.spinnerActive = true
        }
      }

      vm.stopSpin = () => {
        if (vm.spinnerActive) {
          usSpinnerService.stop('spinner-2')
          vm.spinnerActive = false
        }
      }

      vm.hidePositionFromUI = position => {
        const selectedEmployer = vm.candidateEmployerRecommendations.find(
          ({employer}) => employer.id === position.employerId
        )
        vm.hiddenPositions++

        if (selectedEmployer.totalPositions > 1)
          vm['jobRow' + position.id] = 'zoomOutRight'
        else {
          selectedEmployer.expanded = false
          vm['firmRow' + position.employerId] = 'zoomOutRight'
        }

        try {
          console.debug('analytics: not for me', position)
          analytics.track('Selected Team Not For Me', {
            lawyer_id: vm.user.id,
            job_id: position.id,
            job_title: position.title,
            job_max_pqe: position.lawPreferences.maxPqe,
            job_min_pqe: position.lawPreferences.minPqe,
            job_contract: position.contractTypeName,
            job_role: position.occupationId,
            firm_id: position.employerId,
            firm_name: position.employerName,
            employer_type:
              position.employerTypes.filter(
                ({name}) => name === 'Private Practice'
              ).length > 0
                ? 'Private Practice'
                : 'In-House',
            page: 'Make Me An Offer',
          })
        } catch (error) {
          console.error('Make Me An Offer', error)
        }

        $timeout(() => {
          vm.totalPositions--
          vm.countRefreshReq = true

          if (selectedEmployer.totalPositions > 1) {
            selectedEmployer.positions = selectedEmployer.positions.filter(
              ({id}) => id !== position.id
            )
            vm['jobRow' + position.id] = ''
            selectedEmployer.totalPositions--
          } else {
            vm.candidateEmployerRecommendations = vm.candidateEmployerRecommendations.filter(
              ({employer}) => employer.id !== position.employerId
            )
            vm.noEmployers = vm.candidateEmployerRecommendations.length <= 0

            vm['firmRow' + position.employerId] = ''
          }
        }, 900)
      }

      vm.hideEmployerFromUI = position => {
        const selectedEmployer = vm.candidateEmployerRecommendations.find(
          ({employer}) => employer.id === position.employerId
        )
        selectedEmployer.expanded = false
        vm['firmRow' + position.employerId] = 'zoomOutRight'
        try {
          analytics.track('Selected Firm Not For Me', {
            lawyer_id: vm.user.id,
            employer_type:
              position.employerTypes.filter(
                ({name}) => name === 'Private Practice'
              ).length > 0
                ? 'Private Practice'
                : 'In-House',
            firm_id: position.employerId,
            firm_name: position.employer.name,
            page: 'Make Me An Offer',
          })
        } catch (error) {
          console.error('Make Me An Offer', error)
        }

        $timeout(() => {
          vm.candidateEmployerRecommendations = vm.candidateEmployerRecommendations.filter(
            ({employer}) => employer.id !== position.employerId
          )
          vm.noEmployers = vm.candidateEmployerRecommendations.length <= 0
          vm.totalPositions =
            Number.parseInt(vm.totalPositions, 10) -
            Number.parseInt(selectedEmployer.totalPositions, 10)
          vm.hiddenPositions =
            Number.parseInt(vm.hiddenPositions, 10) +
            Number.parseInt(selectedEmployer.totalPositions, 10)

          vm.countRefreshReq = true
          vm['firmRow' + position.employerId] = ''
        }, 900)
      }

      vm.unHidePosition = async position => {
        const unHiddenEmployer = vm.candidateEmployerRecommendations.find(
          ({employer}) => employer.id === position.employerId
        )
        if (position.employerHidden && !position.positionHidden) {
          const payload = {
            employerIds: [Number.parseInt(position.employerId, 10)],
            updateValue: false,
          }
          try {
            await MatchesApi.unHideCandidateEmployer(position.userId, payload)
            unHiddenEmployer.positions.forEach(unHiddenEmployerPosition => {
              unHiddenEmployerPosition.employerHidden = false
            })

            if (
              unHiddenEmployer.positions.find(
                ({positionHidden}) => positionHidden === true
              )
            ) {
              unHiddenEmployer.positions.forEach(unHiddenEmployerPosition => {
                if (!unHiddenEmployerPosition.positionHidden) {
                  vm['jobRow' + unHiddenEmployerPosition.id] = 'zoomOutLeft'
                }
              })
            } else {
              unHiddenEmployer.expanded = false
              vm['firmRow' + unHiddenEmployer.employer.id] = 'zoomOutLeft'
            }

            $scope.$apply()

            $timeout(() => {
              if (
                unHiddenEmployer.positions.find(
                  ({positionHidden}) => positionHidden === true
                )
              ) {
                unHiddenEmployer.positions.forEach(unHiddenEmployerPosition => {
                  if (!unHiddenEmployerPosition.positionHidden) {
                    vm['jobRow' + unHiddenEmployerPosition.id] = ''
                  }
                })

                unHiddenEmployer.positions = unHiddenEmployer.positions.filter(
                  ({positionHidden}) => positionHidden
                )
                vm.totalPositions =
                  Number.parseInt(vm.totalPositions, 10) +
                  Number.parseInt(unHiddenEmployer.totalPositions, 10) -
                  unHiddenEmployer.positions.length
                vm.hiddenPositions =
                  Number.parseInt(vm.hiddenPositions, 10) -
                  Number.parseInt(unHiddenEmployer.totalPositions, 10) +
                  unHiddenEmployer.positions.length
                unHiddenEmployer.totalPositions =
                  unHiddenEmployer.positions.length
              } else {
                vm.candidateEmployerRecommendations = vm.candidateEmployerRecommendations.filter(
                  ({employer}) => employer.id !== position.employerId
                )
                vm.noEmployers = vm.candidateEmployerRecommendations.length <= 0

                vm['firmRow' + unHiddenEmployer.employer.id] = ''

                vm.noEmployers = vm.candidateEmployerRecommendations.length <= 0
                vm.totalPositions =
                  Number.parseInt(vm.totalPositions, 10) +
                  Number.parseInt(unHiddenEmployer.totalPositions, 10)
                vm.hiddenPositions =
                  Number.parseInt(vm.hiddenPositions, 10) -
                  Number.parseInt(unHiddenEmployer.totalPositions, 10)
              }

              vm.countRefreshReq = true
            }, 900)
          } catch (error) {
            vm['firmRow' + position.employerId] = 'fadeIn'
            logger.notify('error', `somthing went wrong: ${error.statusText}`)
          }
        } else if (!position.employerHidden && position.positionHidden) {
          const payload = {
            positionIds: [Number.parseInt(position.id, 10)],
            hide: false,
            reason: ' ',
          }
          try {
            await MatchesApi.unHideCandidatePosition(position.userId, payload)
            vm.totalPositions++
            if (unHiddenEmployer.totalPositions > 1)
              vm['jobRow' + position.id] = 'zoomOutLeft'
            else {
              unHiddenEmployer.expanded = false
              vm['firmRow' + position.employerId] = 'zoomOutLeft'
            }

            $scope.$apply()
            $timeout(() => {
              vm.hiddenPositions--
              vm.countRefreshReq = true
              vm['jobRow' + position.id] = ''
              if (unHiddenEmployer.totalPositions > 1) {
                unHiddenEmployer.positions = unHiddenEmployer.positions.filter(
                  ({id}) => id !== position.id
                )
                unHiddenEmployer.totalPositions--
                vm['jobRow' + position.id] = ''
              } else {
                vm.candidateEmployerRecommendations = vm.candidateEmployerRecommendations.filter(
                  ({employer}) => employer.id !== position.employerId
                )
                vm.noEmployers = vm.candidateEmployerRecommendations.length <= 0

                vm['firmRow' + position.employerId] = ''
              }
            }, 900)
          } catch (error) {
            vm['jobRow' + position.id] = 'fadeIn'

            logger.notify('error', `somthing went wrong: ${error.statusText}`)
          }
        } else if (position.employerHidden && position.positionHidden) {
          const positionUnHidePayLoad = {
            positionIds: [Number.parseInt(position.id, 10)],
            hide: false,
            reason: ' ',
          }
          const employerUnHidePayLoad = {
            employerIds: [Number.parseInt(position.employerId, 10)],
            updateValue: false,
          }
          try {
            await MatchesApi.unHideCandidatePosition(
              position.userId,
              positionUnHidePayLoad
            )
            await MatchesApi.unHideCandidateEmployer(
              position.userId,
              employerUnHidePayLoad
            )
            unHiddenEmployer.positions.forEach(unHiddenEmployerPosition => {
              unHiddenEmployerPosition.employerHidden = false
            })
            if (
              unHiddenEmployer.positions.find(
                unHiddenEmployerPosition =>
                  unHiddenEmployerPosition.positionHidden === true &&
                  unHiddenEmployerPosition.id !== position.id
              )
            ) {
              unHiddenEmployer.positions.forEach(unHiddenEmployerPosition => {
                if (
                  !unHiddenEmployerPosition.positionHidden ||
                  unHiddenEmployerPosition.id === position.id
                ) {
                  vm['jobRow' + unHiddenEmployerPosition.id] = 'zoomOutLeft'
                }
              })
            } else {
              unHiddenEmployer.expanded = false
              vm['firmRow' + unHiddenEmployer.employer.id] = 'zoomOutLeft'
            }

            $scope.$apply()

            $timeout(() => {
              if (
                unHiddenEmployer.positions.find(
                  unHiddenEmployerPosition =>
                    unHiddenEmployerPosition.positionHidden === true &&
                    unHiddenEmployerPosition.id !== position.id
                )
              ) {
                unHiddenEmployer.positions.forEach(unHiddenEmployerPosition => {
                  if (
                    !unHiddenEmployerPosition.positionHidden ||
                    unHiddenEmployerPosition.id === position.id
                  ) {
                    vm['jobRow' + unHiddenEmployerPosition.id] = ''
                  }
                })

                unHiddenEmployer.positions = unHiddenEmployer.positions.filter(
                  unHiddenEmployerPosition =>
                    unHiddenEmployerPosition.positionHidden === true &&
                    unHiddenEmployerPosition.id !== position.id
                )
                vm.totalPositions =
                  Number.parseInt(vm.totalPositions, 10) +
                  Number.parseInt(unHiddenEmployer.totalPositions, 10) -
                  unHiddenEmployer.positions.length
                vm.hiddenPositions =
                  Number.parseInt(vm.hiddenPositions, 10) -
                  Number.parseInt(unHiddenEmployer.totalPositions, 10) +
                  unHiddenEmployer.positions.length
                unHiddenEmployer.totalPositions =
                  unHiddenEmployer.positions.length
              } else {
                vm.candidateEmployerRecommendations = vm.candidateEmployerRecommendations.filter(
                  ({employer}) => employer.id !== position.employerId
                )
                vm.noEmployers = vm.candidateEmployerRecommendations.length <= 0

                vm['firmRow' + unHiddenEmployer.employer.id] = ''

                vm.noEmployers = vm.candidateEmployerRecommendations.length <= 0
                vm.totalPositions =
                  Number.parseInt(vm.totalPositions, 10) +
                  Number.parseInt(unHiddenEmployer.totalPositions, 10)
                vm.hiddenPositions =
                  Number.parseInt(vm.hiddenPositions, 10) -
                  Number.parseInt(unHiddenEmployer.totalPositions, 10)
              }

              vm.countRefreshReq = true
            }, 900)
          } catch (error) {
            vm['jobRow' + position.id] = 'fadeIn'

            logger.notify('error', `somthing went wrong: ${error.statusText}`)
          }
        }
      }

      vm.onExpandEmployer = (employerDetails, employerPositions) => {
        try {
          /* eslint-disable camelcase */
          analytics.track('Explored Firm', {
            lawyer_id: vm.candidate.user.id,
            employer_type:
              employerDetails.employerTypes.filter(
                ({name}) => name === 'Private Practice'
              ).length > 0
                ? 'Private Practice'
                : 'In-House',
            firm_id: employerDetails.employer.id,
            firm_name: employerDetails.employer.name,
            job_count: employerDetails.totalPositions,
            job_ids: employerPositions,
            page: 'Make Me An Offer',
          })
          /* eslint-enable camelcase */
        } catch (error) {
          console.error('Make Me An Offer', error)
        }
      }

      vm.notify = (type, message) => {
        switch (type) {
          case 'info':
            logger.log(message)
            break
          case 'success':
            logger.logSuccess(message)
            break
          case 'warning':
            logger.logWarning(message)
            break
          case 'error':
            logger.logError(message)
            break
          default:
        }
      }

      vm.getAllEmployerLogos = employers => {
        employers.map(async ({employer}) => {
          if (employer.logo) {
            employer.logoSrc = `${process.env.PUBLIC_BUCKET_URL}/employers/${employer.id}/logo/${employer.logo}`
            return employer
          }

          employer.logoSrc = vm.picSrc
          return employer
        })
        $scope.$apply()
      }

      vm.OnChangePracticeArea = async (event, selectedPracticeArea) => {
        if (event) {
          event.stopPropagation()
        } else {
          vm.selectedPracticeArea = selectedPracticeArea
          if (vm.selectedPracticeArea) {
            try {
              analytics.track('Practice Areas Filter Selected', {
                // eslint-disable-next-line camelcase
                lawyer_id: vm.user.id,
                // eslint-disable-next-line camelcase
                filtered_practice_area: vm.selectedPracticeArea.name,
                page: 'Make Me An Offer',
              })
            } catch (error) {
              console.error('Make Me An Offer:', error)
            }

            await vm.select(vm.currentPage)
            vm.applyFilterCheck = false
          }
        }
      }

      vm.onChangeLocation = async (event, selectedLocations) => {
        if (event) {
          event.stopPropagation()
        } else {
          vm.selectedLocations = selectedLocations
          if (vm.selectedLocations) {
            try {
              analytics.track('Locations Filter Selected', {
                // eslint-disable-next-line camelcase
                lawyer_id: vm.user.id,
                // eslint-disable-next-line camelcase
                filtered_location: vm.selectedLocations.name,
                page: 'Make Me An Offer',
              })
            } catch (error) {
              console.error('Make Me An Offer', error)
            }

            await vm.select(vm.currentPage)
            vm.applyFilterCheck = false
          }
        }
      }

      vm.hiddenJobFilter = async () => {
        vm.noEmployers = false
        if (vm.fetchHiddenJobs) {
          vm.fetchHiddenJobs = false
        } else {
          vm.fetchHiddenJobs = true
        }

        await vm.select(1)
      }

      const getPositionsForEmployers = async (userId, employerId) => {
        const doGet = async (userId, employerId) => {
          console.debug(
            'MakeMeAnOffer::getPositionsForEmployers',
            userId,
            employerId
          )

          try {
            const payload = {
              hiddenPositions: vm.fetchHiddenJobs,
              locations: vm.selectedLocations
                ? vm.selectedLocations.length > 0
                  ? vm.selectedLocations.map(({id}) => id)
                  : [0]
                : undefined,
              practiceAreas: vm.selectedPracticeArea
                ? vm.selectedPracticeArea.length > 0
                  ? vm.selectedPracticeArea.map(({id}) => id)
                  : [0]
                : undefined,
              positionTypes: ['Speculative', 'Connect'],
              employers: [employerId],
            }
            console.log('payload', payload)
            const {data: matches} = await MatchesApi.getCandidateMatchesData(
              userId,
              payload
            )

            console.debug('getPositionsForEmployers::matches', matches)

            const candidatePqe =
              vm.candidate &&
              vm.candidate.lawProfile &&
              vm.candidate.lawProfile.qualificationDate
                ? formatQualificationDateToPqe(
                    vm.candidate.lawProfile.qualificationDate
                  )
                : false

            console.log('candidatePqe:', candidatePqe, vm.candidate)
            const parsePqe = ({minPqe, maxPqe}) => {
              return {
                minPqe:
                  minPqe !== undefined && minPqe !== null
                    ? Number.parseFloat(minPqe)
                    : -2,
                maxPqe:
                  maxPqe !== undefined && maxPqe !== null
                    ? Number.parseFloat(maxPqe)
                    : +11,
              }
            }

            const matchedByPQE = matches.positions.filter(match => {
              const lawPreferences = match.lawPreferences

              const {minPqe, maxPqe} = parsePqe(lawPreferences)

              const paddedMinPqe = minPqe >= -1 ? minPqe - 1 : -2
              const paddedMaxPqe = maxPqe <= 10 ? maxPqe + 1 : 11

              if (!candidatePqe) {
                return true
              }

              return (
                candidatePqe >= paddedMinPqe && candidatePqe <= paddedMaxPqe
              )
            })

            const processed = matchedByPQE.map(position => {
              const employerSource = vm.candidateEmployerRecommendations.find(
                ({employer}) => employer.id === position.employerId
              )

              const logoSource =
                employerSource &&
                employerSource.employer &&
                employerSource.employer.logoSrc

              const employer = _.extend(position.employer, {
                logoSrc: logoSource,
              })

              const processDescription = position => {
                const hasDescription = position && position.description
                const longDescription =
                  hasDescription && position.description.length > 600
                return {
                  isCollapsed: true,
                  moreDetail: true,
                  showButton: longDescription,
                }
              }

              const extras = processDescription(position)

              const locations =
                position.locations.length > 0
                  ? vm.locationsList
                      .filter(({id}) =>
                        position.locations.find(location => location === id)
                      )
                      .map(location => ({
                        name: location.name,
                        parent: location.parent,
                        color: location.country.region.color,
                      }))
                  : []

              const withEmployer = _.extend(position, employer)
              const withExtras = _.extend(withEmployer, extras)
              const withLocations = _.extend(withExtras, {locations})
              return withLocations
            })

            vm.employerPositions = processed
            vm.applyFilterCheck = true
            // Vm.disabledToolTip(vm.candidate)

            console.debug(
              'MakeMeAnOffer::getPositionsForEmployers:loaded',
              vm.employerPositions
            )

            $scope.$applyAsync()
            return processed
          } catch (error) {
            logger.notify('error', `something went wrong: ${error.statusText}`)
            return []
          }
        }

        // Return wrap(async () => doGet(userId, employerId))
        return doGet(userId, employerId)
      }

      vm.showPositions = async employerDetails => {
        console.debug('MakeMeAnOffer::showPositions', employerDetails)
        try {
          if (employerDetails.expanded === true) {
            console.debug('MakeMeAnOffer::showPositions::expanded', true)
            employerDetails.expanded = false
          } else if (
            employerDetails.expanded === false &&
            employerDetails.totalPositions > 0 &&
            (!employerDetails.positions ||
              employerDetails.positions.length === 0)
          ) {
            // Vm.startSpin()
            console.debug(
              'MakeMeAnOffer::showPositions::expanding (and loading positions)'
            )
            const positionsForEmployers = await getPositionsForEmployers(
              vm.candidate.user.id,
              employerDetails.employer.id
            )

            employerDetails.positions = positionsForEmployers
            // Vm.stopSpin()
            employerDetails.expanded = true

            vm.onExpandEmployer(
              employerDetails,
              vm.employerPositions.map(({id}) => id)
            )
          } else if (
            employerDetails.expanded === false &&
            (employerDetails.positions || employerDetails.positions.length > 0)
          ) {
            console.debug(
              'MakeMeAnOffer::showPositions::expanding (have positions already)',
              true
            )
            employerDetails.expanded = true
          }
        } catch (error) {
          console.error(error)
          vm.stopSpin()
          logger.notify('error', `something went wrong: ${error.statusText}`)
        }
      }

      vm.getCandidateEmployerRecommendations = async (id, payload) => {
        try {
          vm.startSpin()

          const {
            data: candidateEmployerRecommendations,
          } = await MakeMeAnOfferApi.getCandidateEmployerRecommendations(
            id,
            payload,
            vm.candidate
          )

          vm.candidateEmployerRecommendations =
            candidateEmployerRecommendations.employers

          vm.noEmployers = vm.candidateEmployerRecommendations.length <= 0
          vm.positionsCount = candidateEmployerRecommendations.positionsCount
          vm.totalPositions =
            vm.positionsCount.totalPositions - vm.positionsCount.hiddenPositions
          vm.hiddenPositions = vm.positionsCount.hiddenPositions

          vm.getAllEmployerLogos(vm.candidateEmployerRecommendations)
          vm.applyFilterCheck = true
          vm.stopSpin()
          // Vm.disabledToolTip(vm.candidate)
          $scope.$applyAsync()
        } catch (error) {
          vm.stopSpin()
          logger.notify('error', `something went wrong: ${error.statusText}`)
        }
      }

      vm.select = async page => {
        vm.currentPage = page

        const payload = {
          limit: vm.numPerPage,
          page: page,
          hiddenPositions: vm.fetchHiddenJobs,
          locations: vm.selectedLocations
            ? vm.selectedLocations.length > 0
              ? vm.selectedLocations.map(({id}) => id)
              : [0]
            : undefined,
          practiceAreas: vm.selectedPracticeArea
            ? vm.selectedPracticeArea.length > 0
              ? vm.selectedPracticeArea.map(({id}) => id)
              : [0]
            : undefined,
          positionTypes: ['Speculative', 'Connect'],
        }

        await vm.getCandidateEmployerRecommendations(vm.user.id, payload)
      }

      vm.onNumPerPageChange = async () => {
        await vm.select(1)
        vm.currentPage = 1
      }

      vm.getEmployerTypeLogo = employerDetails => {
        return employerDetails.employerTypes.filter(
          ({name}) => name === 'Private Practice'
        ).length > 0
          ? '/images/Private.png'
          : '/images/Inhouse.png'
      }

      vm.loadMatchesJobs = () => {
        $location.url('/matches')
      }

      vm.updateProfileAlertStatus = (alertType, status) => {
        if (alertType === 'both') {
          vm.candidate.profileCvAlertCollapsed = status
          vm.candidate.profilePhoneAlertCollapsed = status
        } else {
          vm.candidate[alertType] = status
        }
      }

      vm.toggleFollowEmployer = async (employerDetail, event) => {
        event.stopPropagation()
        event.preventDefault()
        await wrap(async () => {
          try {
            if (employerDetail.candidateFollowing) {
              employerDetail.followLabel = 'Follow'
              await CandidateProfileApi.unFollowEmployer(
                vm.candidate.user.id,
                employerDetail.employer.id
              )
              employerDetail.candidateFollowing = false
            } else {
              employerDetail.followLabel = 'Following'
              await CandidateProfileApi.followEmployer(
                vm.candidate.user.id,
                employerDetail.employer.id
              )
              employerDetail.candidateFollowing = true
            }
          } catch (error) {
            logger.notify('error', `something went wrong: ${error.statusText}`)
          }
        })
      }

      vm.showMore = job => {
        job.isCollapsed = !job.isCollapsed
      }

      vm.showLess = position => {
        position.isCollapsed = !position.isCollapsed
        vm.jumpToLink(position.id)
      }

      vm.jumpToLink = id => {
        var oldHash
        oldHash = $location.hash()
        $location.hash(id)
        $anchorScroll()
        $location.hash(oldHash)
      }

      vm.locationBackgroundColor = location => {
        if (location) {
          const color = location.color
          const parent = location.parent
          const countryCode =
            parent && parent.countryCode ? parent.countryCode : ''
          if (countryCode === 'GB') {
            return 'london'
          }

          return color
        }

        return 'grey'
      }

      vm.askQuestion = (position, event) => {
        event.preventDefault()
        event.stopPropagation()

        $uibModal.open({
          backdrop: 'static',
          templateUrl: 'contact-admin-modal.html',
          controller: 'ContactAdminController',
          controllerAs: 'ctrl',
          resolve: {
            selectedPosition: function() {
              return position
            },
          },
        })
      }

      vm.initializeMakeMeAnOfferPage = async () => {
        const user = await userService.getUser()
        vm.user = user
        const {data: locationsList} = await SharedApi.getAllLocations({
          supported: true,
          regions: true,
        })
        vm.locationsList = locationsList

        const {data: candidate} = await CandidateProfileApi.getUserProfile(
          user.id,
          {
            include: ['occupations', 'preferredContractTypes', 'school'],
          }
        )
        vm.candidate = candidate

        const {data} = await CandidateProfileApi.getUserProfile(user.id, {
          include: ['preferredLocations'],
        })
        vm.candidate.preferredLocations = data.preferredLocations

        vm.candidate.user.logoSrc = vm.candidate.user.profilePicture
          ? `${process.env.PUBLIC_BUCKET_URL}/user/${candidate.user.id}/photo/${candidate.user.profilePicture}`
          : 'images/defaultPic.jpg'

        const {data: resumes} = await CandidateProfileApi.getUserResumes(
          user.id
        )

        vm.candidate.resumes = resumes
        vm.candidate.profileCvAlertCollapsed = false
        vm.candidate.profilePhoneAlertCollapsed = false
        vm.candidateAgent = await sharedProperties.getAgentDetails(
          vm.candidate.agent
        )

        const {data: legalPracticeAreaList} = await SharedApi.getCategoryById(1)
        vm.legalPracticeAreaList = legalPracticeAreaList

        vm.candidateSpecialties = practiceAreaService.makeCandidatePracticeAreasHierarchy(
          candidate.category,
          vm.legalPracticeAreaList.specialties
        )

        vm.regionHierarchialListWithEuropeOnTop = locationsGenericService.makeCandidateLocationsHierarchy(
          vm.candidate.preferredLocations,
          vm.locationsList
        )

        await vm.onNumPerPageChange()
        $scope.$applyAsync()
      }

      vm.initializeMakeMeAnOfferPage()
    },
  ])
})()



// WEBPACK FOOTER //
// ./scripts/make-me-offer/make-me-an-offer.ctrl.js